import paymentsConstants from '../../constants/payments';

// Keys match the per-field error state CheckoutForm renders under each Stripe Element.
const stripeValidationErrorFields = {
    incomplete_number: 'cardNumber',
    invalid_number: 'cardNumber',
    incomplete_cvc: 'cardCvc',
    invalid_cvc: 'cardCvc',
    incomplete_expiry: 'cardExpiry',
    invalid_expiry_month: 'cardExpiry',
    invalid_expiry_month_past: 'cardExpiry',
    invalid_expiry_year: 'cardExpiry',
    invalid_expiry_year_past: 'cardExpiry',
};

export const getStripeValidationErrorField = stripeCardError => (
    stripeValidationErrorFields[stripeCardError?.code] || null
);

export const interpretStripeCardError = (stripeCardError) => {
    const { stripeErrorMessages } = paymentsConstants;

    if (stripeCardError?.decline_code) {
        const declineCodeMessage = stripeErrorMessages[stripeCardError.decline_code];
        if (declineCodeMessage) {
            return declineCodeMessage;
        }
    }

    if (stripeCardError?.code) {
        const codeMessage = stripeErrorMessages[stripeCardError.code];
        if (codeMessage) {
            return codeMessage;
        }
        return stripeCardError?.message;
    }

    return stripeCardError?.message || null;
};
